import React from 'react';
import {View} from 'react-native';

import StaticImage from '@/components/StaticImage';
import TouchableCard from '@/components/Touchable/TouchableCard';
import {useThemedStyles} from '@/theme';
import {ITrack} from '@/types/common';
import {ImageSize} from '@/types/media';

import {styles} from './TrackBlock.style';

interface IProps {
  track: ITrack;
  onPlay: () => void;
  onTogglePlay: () => void;
  isCurrentTrack: boolean;
}

const TrackBlockEmbed: React.FC<IProps> = ({
  track,
  onPlay,
  onTogglePlay,
  isCurrentTrack,
}) => {
  const style = useThemedStyles(styles);

  const {lossyArtworkUrl} = track;

  const onTrackCardPress = () => {
    if (isCurrentTrack) {
      onTogglePlay();
    } else {
      onPlay();
    }
  };

  return (
    <TouchableCard
      onPress={onTrackCardPress}
      highlight={isCurrentTrack}
      containerStyle={isCurrentTrack ? style.playingContainer : style.container}
      style={style.track}>
      {() => (
        <>
          {lossyArtworkUrl && (
            <View style={style.artworkContainer}>
              <StaticImage
                width={ImageSize.grid}
                source={{uri: lossyArtworkUrl}}
                // @ts-ignore
                style={style.artwork}
              />
            </View>
          )}
        </>
      )}
    </TouchableCard>
  );
};

export default React.memo(TrackBlockEmbed);
